<div class="info-container" [ngClass]="[current_class, isVisible ? 'visible' : 'hidden']">
    <h1 class="title">{{ title }}</h1>
    <p class="description">{{ description }}</p>
</div>